var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',{attrs:{"is-show-header":!_vm.isMobile}},[_c('twilio-chat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }